import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SetupTourGuidePageRoutingModule } from './setup-tour-guide-routing.module';

import { SetupTourGuidePage } from './setup-tour-guide.page';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SetupTourGuidePageRoutingModule,
    NgxDatatableModule
  ],
  declarations: [SetupTourGuidePage]
})
export class SetupTourGuidePageModule {}
